module.exports = __webpack_public_path__ + "static/images/imgBg05.1301daf.png";